export default {"src":"/_next/static/media/seo.3b56c565.svg","height":398,"width":388};